import smoothscroll from 'smoothscroll-polyfill';

import Alert from './alert';
import Accordion from './accordion';
import Dropdown from './dropdown';
import Input from './input';
import SubpageNav from './subpage-nav';
import HeadingMedia from './heading-media';
import ReadMore from './read-more';
import ShowMoreItems from './show-more-items';
import Table from './table';
import CourseLeaf from './courseleaf';
import Modal from './modal';
import hoverCard from './hover-card';
import MastHeadMedia from './masthead-media';
import SwiperObserver from './swiper-observer';
import { addSticky } from '../utils/sticky';
import {
  handleEpiInputCheckbox,
  handleEpiInputRadio,
  handleEpiDropdown,
  handleEpiSimpleInputs,
  handleEpiHiddenInput,
  handleEpiDuplicatedId,
  handleEpiRadioGroup,
  handleEpiFormSubmit
} from './epi-forms';
import { scrollToDOMNode } from '../utils/dom';

function initGlobalComponents() {
  smoothscroll.polyfill();
  addSticky('[data-sticky-class]');
  _$$('.alert[data-id]').forEach((alert) => new Alert(alert));
  _$$('.accordion').forEach((accordion) => new Accordion(accordion));
  _$$('.field:not(.dropdown)').forEach((field) => new Input(field));
  _$$('.dropdown').forEach((dropdown) => new Dropdown(dropdown));
  _$$('.read-more').forEach((readMore) => new ReadMore(readMore));
  _$$('.more-items').forEach((showMore) => new ShowMoreItems(showMore));
  _$$('table').forEach((table) => new Table(table));
  _$$('.courselink').forEach((courseLeaf) => new CourseLeaf(courseLeaf));
  _$$('.modal').forEach((modal) => new Modal(modal));
  _$$('.swiper-container').forEach((swiper) => new SwiperObserver(swiper));
  _$$('.heading-media[data-video-id]').forEach(
    (media) => new HeadingMedia(media)
  );
  _$$('.masthead-media[data-video-id]').forEach(
    (media) => new MastHeadMedia(media)
  );
  _$$('.subpage-nav').forEach((nav) => new SubpageNav(nav));
  _$$('[data-hoverable]').forEach(hoverCard);
  _$$('.ugc-project .EPiServerForms').forEach(handleEpiFormSubmit);
  _$$('.Form__Element[type="hidden"]').forEach(handleEpiHiddenInput);
  _$$('#__field_').forEach(handleEpiDuplicatedId);
  _$$('[data-f-type="choice"]').forEach(handleEpiRadioGroup);
  _$$('.FormChoice__Input--Radio').forEach(handleEpiInputRadio);
  _$$('.FormChoice__Input--Checkbox').forEach(handleEpiInputCheckbox);
  _$$('.FormSelection select').forEach(handleEpiDropdown);
  _$$('.Form__Element.FormTextbox').forEach(handleEpiSimpleInputs);
  window._on('popstate', (e) => {
    if (
      typeof e.originalEvent?.state !== 'undefined' &&
      e.originalEvent?.state !== null
    ) {
      location.reload();
    }
  });
  scrollToDOMNode();
}

export default initGlobalComponents;
